/*
* Created on Jan 14, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/

import React, { useState } from 'react';
import ic_site_d_layer_svg from "../../static/img/content/ic-site-d-layer.svg";
import {useQuery} from "@tanstack/react-query";
import {useTranslation} from "react-i18next";
import {useOrganizationApi} from "../../hook/OrganizationAPIHook";

const MainContentSummaryRowSiteComponent = ({organization, goSites}) => {
    const {t, i18n} = useTranslation();
    // const {OrganizationAPI} = useOrganizationApi();
    // const organization_id = organization.organization_id;
    // const { status, data, error, isFetching } = useQuery(
    //     [`organization/${organization_id}/site`, i18n.language],
    //     async () => {
    //     const list = await OrganizationAPI.get(`organization/${organization_id}/site`, {limit: 100, lang: i18n.language});
    //     return list;
    // });

    return (
       <div className="col-summary col-groups flex-default !w-16">
            <div className="l-section flex-1">
                <div className="section-title">
                    <span className="ic"><img src={ic_site_d_layer_svg} /></span>
                    <span className="label">{t('@Sites@')}</span>
                </div>
                <div className="total-num">
                    <span>{organization?.sites?.length || 0}</span>
                    {/*<span>{data && data.result && data.result.length || 0}</span>*/}
                    <div className="comp-dropdown">
                        <ul className="comp-dropdown-menu add-scroll overlay-scroll">
                            <li className="section">
                                {organization?.sites && organization.sites.map((s)=>{
                                    return (
                                        <div className="section-items selection" key={s.name} onClick={goSites}>
                                            <div className="item-label">{t(s.name)}</div>
                                        </div>
                                    )
                                })}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MainContentSummaryRowSiteComponent;